<script>
import Vue from 'vue';

export default new Vue();
</script>



// WEBPACK FOOTER //
// src/components/Modules/EventBus.vue